// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FORM - GRID  */

.formulario {
  padding-top: 10px;
  display: flex;
  flex-direction: row;
}

/* INPUTS */

.input-cpf {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 1rem;
}

.ou {
  font-size: 16px;
  display: flex;
  height: 40px;
}

.input-form {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: var(--cDark);
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  background: var(--asAzulClaro);
  border: 1.8px solid var(--pAzul);
  border-radius: 20.5px;
  height: 40px;
  width: 100%;
}

.button-info {
  margin-top: 0.5rem;
}

input::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: var(--cDark);
}

/* TEXTOS */

.contagem {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: var(--cDark);
  margin-top: 0.5rem;
  margin-left: 0.5rem;
}

.buttons {
  display: flex;
  margin-left: 0.5rem;
  height: 40px;
}

.buttons button {
  margin-right: 0.5rem;
}

.icon {
  width: 110px;
  margin-left: 0.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/components/formulario/Formulario-style.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* FORM - GRID  */\n\n.formulario {\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n/* INPUTS */\n\n.input-cpf {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-right: 1rem;\n}\n\n.ou {\n  font-size: 16px;\n  display: flex;\n  height: 40px;\n}\n\n.input-form {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--cDark);\n  padding-left: 10px;\n  padding-right: 10px;\n  box-sizing: border-box;\n  background: var(--asAzulClaro);\n  border: 1.8px solid var(--pAzul);\n  border-radius: 20.5px;\n  height: 40px;\n  width: 100%;\n}\n\n.button-info {\n  margin-top: 0.5rem;\n}\n\ninput::placeholder {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--cDark);\n}\n\n/* TEXTOS */\n\n.contagem {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--cDark);\n  margin-top: 0.5rem;\n  margin-left: 0.5rem;\n}\n\n.buttons {\n  display: flex;\n  margin-left: 0.5rem;\n  height: 40px;\n}\n\n.buttons button {\n  margin-right: 0.5rem;\n}\n\n.icon {\n  width: 110px;\n  margin-left: 0.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
